import React from "react";
import { RequestBox } from "src/components/FeedContainer";
import { ConnectionTypeIconWithHoverTip } from "src/components/Icons";
import { normaliseIdColumnValue } from "src/components/Premises/helpers";
import { PremisesTableRow } from "../types";
import { MessageIcon } from "../MessageIcon";
import { usePremisesNavigation } from "../hooks";

export const PremiseBox = ({ row }: { row: PremisesTableRow }) => {
  const { handleOnClick } = usePremisesNavigation(row);
  const primaryIcon = React.useMemo(
    () => (
      <ConnectionTypeIconWithHoverTip
        type={row.connectionType}
        state={row.state}
        requestChannel={row.requestChannel}
      />
    ),
    [row.connectionType, row.state, row.requestChannel]
  );

  const secondaryText = React.useMemo(
    () =>
      normaliseIdColumnValue(
        row.id,
        row.journeyId,
        row.distributorApplicationId
      ),
    [row.id, row.journeyId, row.distributorApplicationId]
  );

  const secondaryIcon = React.useMemo(
    () => <MessageIcon unread={row.hasUnreadMessage} />,
    [row.hasUnreadMessage]
  );

  return (
    <RequestBox
      primaryIcon={primaryIcon}
      primaryText={row.address}
      secondaryIcon={secondaryIcon}
      secondaryText={secondaryText}
      summaryText={row.statusText}
      onClick={handleOnClick}
      data-id={`premiseBox.${row.id}`}
    />
  );
};
